import { render, staticRenderFns } from "./EsamiSpecialisticiIntegrativiViewComponent.vue?vue&type=template&id=75c622c8"
import script from "./EsamiSpecialisticiIntegrativiViewComponent.vue?vue&type=script&lang=js"
export * from "./EsamiSpecialisticiIntegrativiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports